import { useMutation } from '@apollo/client';
import { date } from '@crehana/utils';

import AcademyActivationRouteMutation from './graphql/AcademyActivationRoute.v4.b2b.graphql';
import AcademyCreateUsersMutation from './graphql/AcademyCreateUsers.v4.b2b.graphql';
import type {
  AcademyActivationRoute,
  AcademyActivationRouteVariables,
} from './graphql/types/AcademyActivationRoute';
import type {
  AcademyCreateUsers,
  AcademyCreateUsersVariables,
} from './graphql/types/AcademyCreateUsers';

interface UseAcademyActivationProps {
  organizationSlug: string;
  teamId: number;
  startDate: Date | null;
  endDate: Date | null;
  userIds: number[];
}

const useAcademyActivation = ({
  organizationSlug,
  teamId,
  startDate,
  endDate,
  userIds,
}: UseAcademyActivationProps) => {
  const [activateAcademy, { loading: isLoadingActivateAcademy }] = useMutation<
    AcademyActivationRoute,
    AcademyActivationRouteVariables
  >(AcademyActivationRouteMutation, {
    context: { clientName: 'v4.b2b' },
    variables: {
      organizationSlug,
      teamId,
      startDate: startDate ? date.format(startDate, 'YYYY-MM-DD') : null,
      endDate: endDate ? date.format(endDate, 'YYYY-MM-DD') : null,
    },
  });

  const [createUserTeam, { loading: isLoadingCreateUserTeam }] = useMutation<
    AcademyCreateUsers,
    AcademyCreateUsersVariables
  >(AcademyCreateUsersMutation, {
    context: { clientName: 'v4.b2b' },
    variables: {
      organizationSlug,
      teamId,
      numberCourses: 1,
      userIds,
    },
  });

  return {
    activateAcademy,
    createUserTeam,
    isLoadingActivateAcademy,
    isLoadingCreateUserTeam,
  };
};

export default useAcademyActivation;
